export * from './IconArrowRight';
export { default as IconArrowRight } from './IconArrowRight';
